import {Component, input} from '@angular/core';
import {FormGroup, Validators} from '@angular/forms';
import dayjs from 'dayjs';
import {ProjectPhase} from '../../services/project-phases/project-phase.model';
import {dateBetweenValidator} from '../../core/utils/date-between.validator';
import {dateAfterControlValidator} from '../../core/utils/date-after-control-validator.util';
import {SubTableBaseComponent} from '../../core/base/sub-table-base.component';
import {getIsoFormat} from '../../core/utils/iso-format.util';

@Component({
	selector: 'tvsub-project-phases-table',
	templateUrl: './project-phases-table.component.html',
	styleUrls: ['./project-phases-table.component.scss'],
	standalone: false
})
export class ProjectPhasesTableComponent extends SubTableBaseComponent<ProjectPhase> {
	start = input<[number, number, number] | null>(null);
	end = input<[number, number, number] | null>(null);
	descriptionLabel = input('Onderwerp');

	minStart: Date;
	maxEnd: Date;

	protected override beforeInit() {
		const start = this.start() || [2000, 1, 1];
		const end = this.end() || [2999, 12, 31];

		this.minStart = new Date(start[0], start[1] - 1, start[2], 0, 0, 0);
		this.maxEnd = new Date(end[0], end[1] - 1, end[2], 23, 59, 59);
	}

	protected override convertLineToData(item: any): ProjectPhase {
		return {
			...item,
			startDate: getIsoFormat(item.startDate),
			endDate: getIsoFormat(item.endDate),
		};
	}

	protected override createLineGroup(pp?: ProjectPhase): FormGroup {
		const group = this.fb.group({
			fid: [this.createFrontendID()],
			id: [pp?.id],
			description: [pp?.description, Validators.required],
			startDate: [pp?.startDate ? dayjs(pp?.startDate) : null, [Validators.required, dateBetweenValidator(this.minStart, this.maxEnd)]],
			endDate: [pp?.endDate ? dayjs(pp?.endDate) : null],
		});

		group.get('endDate')!.setValidators([Validators.required, dateBetweenValidator(this.minStart, this.maxEnd), dateAfterControlValidator(group.get('startDate')!)]);

		this.controlShouldTriggerValidation('startDate', 'endDate', group);

		return group;
	}
}
